import { render, staticRenderFns } from "./RecordList.vue?vue&type=template&id=6e132c56&scoped=true"
import script from "./RecordList.vue?vue&type=script&lang=js"
export * from "./RecordList.vue?vue&type=script&lang=js"
import style0 from "./RecordList.vue?vue&type=style&index=0&id=6e132c56&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e132c56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e132c56')) {
      api.createRecord('6e132c56', component.options)
    } else {
      api.reload('6e132c56', component.options)
    }
    module.hot.accept("./RecordList.vue?vue&type=template&id=6e132c56&scoped=true", function () {
      api.rerender('6e132c56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/traddingWitness/openBidWitness/components/RecordList.vue"
export default component.exports